import React, { useState } from 'react';
import styles from './ProductAnnouncementsPanel.module.css';

interface Announcement {
  id: number;
  title: string;
  description: string;
  date: string;
  views: number;
  likes: number;
  image?: string;
}

interface ProductAnnouncementsPanelProps {
  announcements: Announcement[];
}

const tabs = [
  "What's New",
  'Document & Knowledge updates',
  'Recommended Learnings',
  'Community Trends',
];

export const ProductAnnouncementsPanel: React.FC<ProductAnnouncementsPanelProps> = ({
  announcements,
}) => {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <div className={styles.announcementsPanel}>
      <div className={styles.tabs}>
        {tabs.map((tab, index) => (
          <button
            key={index}
            className={`${styles.tab} ${activeTab === index ? styles.tabActive : ''}`}
            onClick={() => setActiveTab(index)}
          >
            {tab}
          </button>
        ))}
      </div>

      <div className={styles.content}>
        {announcements.map((announcement) => (
          <div key={announcement.id} className={styles.announcementCard}>
            <div className={styles.announcementImage}>
              {announcement.image ? (
                <img src={announcement.image} alt={announcement.title} />
              ) : (
                <div className={styles.placeholderImage}>
                  <svg width="44" height="44" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M12 2L4 5V11C4 16.55 7.42 21.74 12 23C16.58 21.74 20 16.55 20 11V5L12 2Z"
                      fill="#38bdf8"
                      fillOpacity="0.45"
                      stroke="#38bdf8"
                      strokeWidth="1.75"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
              )}
            </div>
            <div className={styles.announcementBody}>
              <div className={styles.announcementMain}>
                <h4 className={styles.announcementTitle}>{announcement.title}</h4>
                <p className={styles.announcementDescription} dangerouslySetInnerHTML={{ __html: announcement.description }}></p>
                <div className={styles.announcementMeta}>
                  <div className={styles.metaItem}>
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                      <line x1="16" y1="2" x2="16" y2="6"></line>
                      <line x1="8" y1="2" x2="8" y2="6"></line>
                      <line x1="3" y1="10" x2="21" y2="10"></line>
                    </svg>
                    <span>{announcement.date}</span>
                  </div>
                  <div className={styles.metaItem}>
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                      <circle cx="12" cy="12" r="3"></circle>
                    </svg>
                    <span>{announcement.views.toLocaleString()}</span>
                  </div>
                  <div className={styles.metaItem}>
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3"></path>
                    </svg>
                    <span>{announcement.likes}</span>
                  </div>
                </div>
              </div>
              <div className={styles.announcementArrow}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="9 18 15 12 9 6"></polyline>
                </svg>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className={styles.footer}>
        <button className={styles.viewAllButton}>View All</button>
      </div>
    </div>
  );
};
